import { Injectable } from '@angular/core';
import {OptionRegion} from "../../shared/models/option-region.model";
import {first, map} from "rxjs/operators";
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {DbResponse} from "../../shared/interceptors/db-response";

@Injectable({
  providedIn: 'root'
})
export class CreateWebsiteHelpersService {

  constructor(
    private readonly _hostingService: HostingService,
  ) { }

  public getRegions(subscriptionId): Promise<OptionRegion[]> {
    return this._hostingService.regions(subscriptionId)
      .pipe(
        first(response => !!response && response.success),
        map(response => response.data.map(data => new OptionRegion(data))),
      )
      .toPromise();
  }

  private getSubdomainSuggestion(): Promise<string> {
    return this._hostingService.subdomainSuggestion()
      .pipe(
        first(response => !!response && response.success && response.data && response.data.subdomain),
        map(response => response.data.subdomain.toLowerCase())
      )
      .toPromise();
  }

  public getWebsiteCreationInitialData(subscriptionId): Promise<[string, OptionRegion[]]> {
    return Promise.all([this.getSubdomainSuggestion(), this.getRegions(subscriptionId)]);
  }

  public checkDomain(domain: string): Promise<DbResponse> {
    return this._hostingService.checkDomain(domain)
      .pipe(
        first(response => !!response)
      )
      .toPromise();
  }

  public checkSubDomain(subdomain: string): Promise<DbResponse> {
    return this._hostingService.checkSubDomain(subdomain)
      .pipe(
        first(response => !!response)
      )
      .toPromise();
  }
}
